<template>
  <div class="d-flex align-center justify-space-between" style="height: 50px">
    <div class="d-flex align-center">
      <div class="d-flex" style="width: 200px">
        <div style="width: 120px">{{ kind === 'cen' ? 'Học phí:' : 'Chuyên đề:' }}</div>
        <div>
          {{ item[kind].amountPaid.toLocaleString('en-US') }}
        </div>
      </div>
      <div class="d-flex">
        <div class="ml-2">
          <v-icon color="#46BE8A" v-if="item[kind].isPaid">mdi-checkbox-marked-circle</v-icon>
          <v-icon color="#F4BB43" v-else>mdi-cancel</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kind: String,
    item: Object,
  },
}
</script>

<style></style>
